export const QuizMarvel = [
    {
        provider: "Donkey Geek (https://www.youtube.com/c/DonkeyGeek)",
        topic: "Marvel Quiz Application for Learning React JS",
        quiz: {
            beginner: [
                {
                    id: 0,
                    question: "Which team is Iceman a part of?",
                    options: [
                        "The X-Men",
                        "The Fantastic Four",
                        "The Invaders",
                        "The Liberators"
                    ],
                    answer: "The X-Men",
                    heroId: 1009362
                },
                {
                    id: 1,
                    question: "In the X-Men, what substance makes up Wolverine's skeleton?",
                    options: [
                        "Cavorite",
                        "Vibranium",
                        "Adamantium",
                        "Neutronium"
                    ],
                    answer: "Adamantium",
                    heroId: 1009718
                },
                {
                    id: 2,
                    question: "What is the name of the Spider-Man who first appeared in 1962?",
                    options: [
                        "Tom Parker",
                        "John Parker",
                        "Peter Parker",
                        "Alan Parker"
                    ],
                    answer: "Peter Parker",
                    heroId: 1009610
                },
                {
                    id: 3,
                    question: "What was Wolverine's name when he was one of Apocalypse's Horsemen?",
                    options: [
                        "Rage",
                        "Death",
                        "Destruction",
                        "Oblivion"
                    ],
                    answer: "Death",
                    heroId: 1009718
                },
                {
                    id: 4,
                    question: "Which superhero never separates from his hammer forged by dwarves?",
                    options: [
                        "Bizarro",
                        "Flash",
                        "Venom",
                        "Thor"
                    ],
                    answer: "Thor",
                    heroId: 1009664
                },
                {
                    id: 5,
                    question: "What color is associated with Hulk?",
                    options: [
                        "Yellow",
                        "Red",
                        "Green",
                        "Blue"
                    ],
                    answer: "Green",
                    heroId: 1009351
                },
                {
                    id: 6,
                    question: "Which superhero resembles a stone-like being?",
                    options: [
                        "Plastic Man",
                        "The Thing",
                        "Hawkman",
                        "Superboy"
                    ],
                    answer: "The Thing",
                    heroId: 1009662
                },
                {
                    id: 7,
                    question: "Who is Edwin Jarvis the butler for?",
                    options: [
                        "Bruce Wayne",
                        "Charles Xavier",
                        "Tony Stark",
                        "Henry Steven"
                    ],
                    answer: "Tony Stark",
                    heroId: 1009368
                },
                {
                    id: 8,
                    question: "Which superhero wears a costume inspired by the American flag?",
                    options: [
                        "Tigra",
                        "Blade",
                        "Iron Man",
                        "Captain America"
                    ],
                    answer: "Captain America",
                    heroId: 1009220
                },
                {
                    id: 9,
                    question: "Including his thumbs, how many fingers does The Thing have on both hands?",
                    options: [
                        8,
                        6,
                        10,
                        4
                    ],
                    answer: 8,
                    heroId: 1009662
                }
            ],
            "intermediate": [
                {
                    id: 0,
                    question: "Who is Logan in Marvel Comics' 'X-Men'?",
                    options: [
                        "Cyclope",
                        "Colossus",
                        "Wolverine",
                        "Caliban"
                    ],
                    answer: "Wolverine",
                    heroId: 1009718
                },
                {
                    id: 1,
                    question: "Which superhero is interested in Sue Storm?",
                    options: [
                        "X-Men",
                        "Illuminati",
                        "Spider-Man",
                        "Namor"
                    ],
                    answer: "Namor",
                    heroId: 1009466
                },
                {
                    id: 2,
                    question: "Which human becomes super-powered through high-tech armor?",
                    options: [
                        "Cyclope",
                        "Iron Man",
                        "Wolverine",
                        "Thor"
                    ],
                    answer: "Iron Man",
                    heroId: 1009368
                },
                {
                    id: 3,
                    question: "Which of these options refers to an iconic enemy of Spider-Man?",
                    options: [
                        "Lizard",
                        "Thanos",
                        "Void",
                        "Green Goblin"
                    ],
                    answer: "Green Goblin",
                    heroId: 1014985
                },
                {
                    id: 4,
                    question: "GHOST RIDER is known as",
                    options: [
                        "The devil's rider",
                        "The spirit of hatred",
                        "The spirit of vengeance",
                        "The red skull"
                    ],
                    answer: "The spirit of vengeance",
                    heroId: 1009318
                },
                {
                    id: 5,
                    question: "Before becoming Radioactive Man, Chen Lu was...",
                    options: [
                        "A spy",
                        "A nuclear physicist",
                        "A soldier",
                        "A pilot"
                    ],
                    answer: "A nuclear physicist",
                    heroId: 1009526
                },
                {
                    id: 6,
                    question: "Which blind superhero has highly developed sensory organs?",
                    options: [
                        "Daredevil",
                        "Flash",
                        "Superman",
                        "Captain America"
                    ],
                    answer: "Daredevil",
                    heroId: 1009262
                },
                {
                    id: 7,
                    question: "Before turning to a life of crime, Mysterio was...",
                    options: [
                        "Stuntman",
                        "Special effects artist",
                        "Magician",
                        "Firefighter"
                    ],
                    answer: "Special effects artist",
                    heroId: 1010952
                },
                {
                    id: 8,
                    question: "Fin Fang Foom is an alien from...",
                    options: [
                        "Krypton",
                        "Maklu IV",
                        "Mars",
                        "Vulcan"
                    ],
                    answer: "Maklu IV",
                    heroId: 1009303
                },
                {
                    id: 9,
                    question: "DOCTOR DOOM attended the same college as...",
                    options: [
                        "Tony Stark",
                        "Peter Parker",
                        "Reed Richards",
                        "Bruce Banner"
                    ],
                    answer: "Reed Richards",
                    heroId: 1009281
                }
            ],
            "expert": [
                {
                    id: 0,
                    question: "When working for Hydra, Spider-Woman's first mission was to...",
                    options: [
                        "Seduce Iron Man",
                        "Seduce Spider-Man",
                        "Kill The Black Widow",
                        "Kill Nick Fury"
                    ],
                    answer: "Kill Nick Fury",
                    heroId: 1009608
                },
                {
                    id: 1,
                    question: "Which superhero created by Marvel Comics is blind from birth?",
                    options: [
                        "Flash",
                        "Thor",
                        "Cyclope",
                        "Stick"
                    ],
                    answer: "Stick",
                    heroId: 1009626
                },
                {
                    id: 2,
                    question: "Spider-Man was solicited to create the Spider-Mobile by the advertising company of...",
                    options: [
                        "Carter Lombardo",
                        "Max Shrek",
                        "Reed Richards",
                        "Spider Company"
                    ],
                    answer: "Carter Lombardo",
                    heroId: 1009610
                },
                {
                    id: 3,
                    question: "Which Daredevil heroine is a professional assassin?",
                    options: [
                        "Ultron",
                        "Catwoman",
                        "Elektra",
                        "Wonder Woman"
                    ],
                    answer: "Elektra",
                    heroId: 1009288
                },
                {
                    id: 4,
                    question: "Where does Mandarin, recently becoming the ruler of Sin-Cong Wong Chu, reside?",
                    options: [
                        "The Valley of Spirits",
                        "The Mountains of Asgard",
                        "The Canyons of Atlantis",
                        "The Cave of Souls"
                    ],
                    answer: "The Valley of Spirits",
                    heroId: 1009421
                },
                {
                    id: 5,
                    question: "Which superhero has the same powers as Spider-Man?",
                    options: [
                        "Venom",
                        "Green Arrow",
                        "Blade",
                        "Bizarro"
                    ],
                    answer: "Venom",
                    heroId: 1010788
                },
                {
                    id: 6,
                    question: "Nick Fury has an evil brother. What is his name?",
                    options: [
                        "Venom",
                        "Viper",
                        "The Red Skull",
                        "Scorpio"
                    ],
                    answer: "Scorpio",
                    heroId: 1011007
                },
                {
                    id: 7,
                    question: "Miss Marvel has never been known as...",
                    options: [
                        "Captain Marvel",
                        "Rogue",
                        "Warbird",
                        "Binary"
                    ],
                    answer: "Rogue",
                    heroId: 1010338
                },
                {
                    id: 8,
                    question: "Which heroine close to Doctor Strange was created in 1964?",
                    options: [
                        "Felina",
                        "Clea",
                        "Monica",
                        "Elsa"
                    ],
                    answer: "Clea",
                    heroId: 1009239
                },
                {
                    id: 9,
                    question: "As a child, Storm attempted to...",
                    options: [
                        "Set a village on fire with a lightning strike",
                        "Become the leader of a gang",
                        "Steal Professor Xavier's car",
                        "Pickpocket Professor Xavier"
                    ],
                    answer: "Pickpocket Professor Xavier",
                    heroId: 1009629
                }
            ]
        }
    }
];
